// extracted by mini-css-extract-plugin
module.exports = {"text_placeholder":"TextPlaceholder_text_placeholder__PNU6y"};